import React from "react";
import { connect } from "react-redux";
import { Tab } from "semantic-ui-react";
import DataGrid from "../shared/DataGrid";
import Transactions from "./Transactions";
import CommentsTab from "./CommentsTab";

const SecondaryTabs = (props) => {

    const { showEventsGrid, loading, showTicketsGrid, eventsGrid, ticketsGrid } = props.modal;

    let panes = [
      {
        menuItem: 'Transactions',
        pane: <Tab.Pane><Transactions /></Tab.Pane>
      }
    ]
    
    if (showEventsGrid) {
      panes.push(
        {
          menuItem: 'Events',
          pane: <Tab.Pane>
            <DataGrid
              loading={loading}
              headings={eventsGrid.headerDef}
              data={eventsGrid.data}
              rowDef={eventsGrid.rowDef}
              hideOverflow
              onRowClick={() => { }}
              fullHeight
              stretched
              className="h-100"
            />
          </Tab.Pane>
        }
      )
    }

    if (showTicketsGrid) {
      panes.push(
        {
          menuItem: 'Tickets',
          pane: <Tab.Pane>
            <DataGrid
              loading={loading}
              headings={ticketsGrid.headerDef}
              data={ticketsGrid.data}
              rowDef={ticketsGrid.rowDef}
              hideOverflow
              onRowClick={() => { }}
              fullHeight
              stretched
              className="h-100"
            />
          </Tab.Pane>
        }
      )
    }

    panes.push(
      {
        menuItem: 'Comments',
        pane: <Tab.Pane>
          <CommentsTab />
        </Tab.Pane>
      }
    )

    return <Tab renderActiveOnly={false} panes={panes} className="flex-stretch gs-flex-container-vertical h-60" /> 
}
const mapStateToProps = state => {
	return {
    modal: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps)(SecondaryTabs);